import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const HelpIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M12.26 8.02a2 2 0 0 0-2.23 1.31 1 1 0 1 1-1.88-.66A4 4 0 0 1 15.92 10c0 1.53-1.14 2.54-1.95 3.08a8.04 8.04 0 0 1-1.68.85l-.04.01h-.01a1 1 0 0 1-.64-1.89h.02a3.87 3.87 0 0 0 .36-.15c.25-.11.57-.27.89-.48.68-.46 1.05-.95 1.05-1.42a2 2 0 0 0-1.66-1.98ZM12 16a1 1 0 1 0 0 2h.01a1 1 0 1 0 0-2H12Z" />
    <path
      fillRule="evenodd"
      d="M1 12a11 11 0 1 1 22 0 11 11 0 0 1-22 0Zm11-9a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default HelpIcon;
